import { Button } from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../theme/theme";

export const StyledButton = styled(Button)`
  &&&&& {
    position: relative;
    border-width: 2px;
    border-radius: 0px;
    font-size: 15px;
  }
`;

export const ApproveButton = styled(StyledButton)`
  &&&&& { 
    border-color: ${(props) =>
    props.disabled ? theme.buttons.disabled : theme.palette.admin.main};
    color: ${(props) =>
    props.disabled ? theme.buttons.disabled : theme.palette.admin.main};
  }
`;

export const ApproveButton2 = styled(StyledButton)`
  &&&&& {
    font-size: 1em;
    font-weight: 400;
    color:#FFFFFF;
    border-radius:3px;
    background-color:#7500C0;
    outline:1px solid inherit;
    text-transform:capitalize;
  }

  &&&&&&:hover {
    background-color: #A100FF;
    cursor: pointer;
  }
  &&&&&&:disabled {
    background-color: #EBEBEB;
  }
`;

export const AcceptButtonSshUserDialog = styled(StyledButton)`
  &&&&& {
    font-size: 16px;
    font-weight: 600;
    width: 35%;
    border-color: ${(props) =>
    props.disabled ? theme.buttons.disabled : theme.status.running};
    color: ${(props) =>
    props.disabled ? theme.buttons.disabled : theme.status.running};
  }
`;

export const DenyButton = styled(StyledButton)`
  &&&&& {
    border-color: ${theme.status.stopped};
    color: ${theme.status.stopped};
  }
`;

export const DenyButton2 = styled(StyledButton)`
  &&&&& {
    font-size: 1em;
    text-transform:capitalize;
    font-weight: 400;
    color:#FFFFFF;
    border-radius:3px;
    background-color:#7500C0;
    outline:1px solid inherit;
  }

  &&&&&:hover {
    background-color: #A100FF;
    cursor: pointer;
  }
`;

export const SmallButton = styled(Button)`
  &&&&& {
    border-width: 2px;
    height: 35px;
    background-color:#460073;
    border-radius:4px;
    border:1px solid #F5F5F5;
    color:#FFFFFF
  }
  &&&&&:hover {
      background-color:#7500C0;
  }
  &&&&&[disabled] {
      background-color: #B3B2B5;
`;

export const StyledLongButton = styled(Button)`
  &&&&& {
    border-width: 2px;
    border-radius: 0px;
    width: 40%;
    height: 30px;
  }
`;
